function ProductHero({ product }) {
  return (
    <div className="photo-select-hero" data-node-id="6352:17054">
      {product?.thumbnailUrl ? (
        <img src={product.thumbnailUrl} alt={`${product.title} 상품 이미지`} />
      ) : (
        <span className="photo-select-hero__empty">상품 이미지 준비 중</span>
      )}
    </div>
  );
}

function ProductSpecs({ product }) {
  return (
    <dl className="photo-select-specs">
      <div className="photo-select-spec-row">
        <dt>상품 유형</dt>
        <dd>{product?.type || "정보 없음"}</dd>
      </div>
      <div className="photo-select-spec-row">
        <dt>상태</dt>
        <dd>{product?.status || "정보 없음"}</dd>
      </div>
    </dl>
  );
}

function ProductSummarySection({ product }) {
  return (
    <section className="photo-select-product" data-node-id="6359:17514">
      <ProductHero product={product} />
      <div className="photo-select-info">
        <h2>{product?.title || "계약 상품"}</h2>
        <ProductSpecs product={product} />
      </div>
    </section>
  );
}

export { ProductHero, ProductSpecs, ProductSummarySection };
